module.exports = __webpack_public_path__ + "static/media/italy.d098b239.jpg";